import { Divider, Icon, IconButton, Stack, Tooltip, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { CompilationModel } from "@tm/data/compilations"
import { DeleteListButton } from "./DeleteListButton"
import { useFavoriteArticlesStore } from "../../../store"

type Props = {
    compilation: CompilationModel
    onOpenCompilationList(): void
}

export function CompilationInfo({ compilation, onOpenCompilationList }: Props) {
    const { translateText } = useLocalization()
    const { setCompilationToEdit: setEditFavoriteList } = useFavoriteArticlesStore()

    function handleEditButtonClick() {
        setEditFavoriteList({
            ...compilation,
            compilationId: compilation.id,
            type: "edit",
        })
    }

    return (
        <Stack gap={1} mb={2}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="h3">{compilation.name}</Typography>
                <Stack direction="row" gap={0.5}>
                    <Tooltip title={translateText(122)}>
                        <IconButton onClick={handleEditButtonClick} disabled={!compilation.isOwn} variant="contained" size="large">
                            <Icon name="edit_change" />
                        </IconButton>
                    </Tooltip>
                    <DeleteListButton compilation={compilation} onOpenCompilations={onOpenCompilationList} />
                </Stack>
            </Stack>
            <Typography variant="body2">{compilation.description || translateText(12802)}</Typography>
            <Divider />
        </Stack>
    )
}
